import { Component, OnInit, Input } from '@angular/core';
import { HeaderConfig } from '../../../_models/header-config.model';
import { ToggleSidenavService } from '../../../_services/toggle-sidenav.service';
import { AuthenticationService } from '../../../../services/authentication/authentication.service';
import { BaseUserService } from '../../../../services/base-user/base-user.service';

/**
 * A sidenav header component
 */
@Component({
  selector: 'lm-sidenav-header',
  templateUrl: './sidenav-header.component.html',
  styleUrls: ['./sidenav-header.component.scss']
})
export class SidenavHeaderComponent implements OnInit {
  /** The header config object */
  @Input()
  public config: HeaderConfig;

  /** The sidenav's title */
  public title: string;

  /** A boolean indicating whether the sidenav is open */
  public sideNavIsOpen = false;

  /**
   * @param toggleSidenavService - A reference to the sidenav's toggle service
   * @param userService - A reference to the user service
   */
  constructor(
    private toggleSidenavService: ToggleSidenavService,
    private userService: BaseUserService
  ) {}

  /**
   * Method called when the component initialies
   */
  public ngOnInit() {
    this.title = this.config.title;
    this.toggleSidenavService.isToggled.subscribe(result => {
      this.sideNavIsOpen = result;
    });
  }

  /**
   * Method called when the user clicks on the logout button
   */
  public onLogout() {
    this.userService._logoutUser(this.config.logoutRoute);
  }

  /**
   * Method called when the sidenav is toggled
   */
  public onToggleSideNav() {
    this.sideNavIsOpen = !this.sideNavIsOpen;
    this.toggleSidenavService.toggleMenu(this.sideNavIsOpen);
  }
}
